import styled from "styled-components";

import { breakpoints } from "definitions";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 1.2rem;
  width: 100%;

  /* El campo se estira, el botón se queda del ancho de su texto. */
  > div {
    flex: 1 1 auto;
    min-width: 0;
  }

  > a {
    flex: 0 0 auto;
    height: 4.2rem;
  }

  /* El campo trae margen inferior para separarse del renglón siguiente, pero
     acá el botón se alinea contra el borde del margen y queda más abajo que
     el input. El selector va duplicado para ganarle en especificidad a esa
     regla. */
  && > div {
    margin-bottom: 0;
  }

  ${breakpoints.tablet} {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const Legend = styled.p`
  font-family: "Lato";
  font-style: normal;
  font-size: 1.3rem;
  line-height: 1.8rem;
  margin: 0 0 1rem;
  color: #5b6470;
`;
